export default {
  'TEMPLATE' (state) {
    return state.template
  },
  'TEMPLATES' (state) {
    return state.ctemplates
  }
}
